import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { AdminRolesPage } from '@pages/admin';

export const Route = createFileRoute('/$locale/_authenticated/admin/settings/business/roles')({
  component: AdminRolesSettingsRoute,
});

function AdminRolesSettingsRoute() {
  const location = useLocation();

  if (location.pathname.endsWith('/admin/settings/business/roles/audit')) {
    return <Outlet />;
  }

  return <AdminRolesPage />;
}
